// extracted by mini-css-extract-plugin
export var announcementBar = "style-mod--announcement-bar--af2b5";
export var closeButton = "style-mod--close-button--515bd";
export var headerLink = "style-mod--header-link--f3a75";
export var headerText = "style-mod--header-text--c3253";